const generateComparisonColor = (value, reverseComparisonColor) => {
  if (typeof reverseComparisonColor !== 'undefined') {
    if (value > 0) {
      return reverseComparisonColor ? 'red' : 'green';
    }
    if (value < 0) {
      return reverseComparisonColor ? 'green' : 'red';
    }
  }

  return null;
};

export default generateComparisonColor;
